module.exports = __webpack_public_path__ + "img/Hong Kong.3fab1df4.svg";